const headers = {
  name: "Product units",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
    {
      type: "filter",
      name: "status",
      allowClear: true,
      showSearch: false,
      filterOption: true,
      placeholder: "Status",
      value: null,
      options: [
        { value: 0, label: "Inactive" },
        { value: 1, label: "Active" },
      ],
    },
    {
      type: "add",
      path: "/app/products/units/add",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Products",
        path: "/app/products",
      },
      {
        name: "Units",
        path: "",
      },
      {
        name: "Categories",
        path: "/app/products/categories",
      },
      {
        name: "Brands",
        path: "/app/products/brands",
      },
    ],
    total: [
      { value: 0, label: "Total" },
      { value: 0, label: "Active" },
      { value: 0, label: "Inactive" },
    ],
  },
};

export default headers;
